export default __webpack_public_path__ + "static/PesonaEdu-546ccab19ee3a93860ba09ba57c39ae9.jpg";